import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState, selectUtilsState } from 'app/store/app.states';
import { StripeChargeComponent } from 'app/utilerias/Stripe/stripe-charge/stripe-charge.component';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-buy-folios',
  templateUrl: './buy-folios.component.html',
  styleUrls: ['./buy-folios.component.scss']
})
export class BuyFoliosComponent implements OnInit {

  paquetes: any[];
  operation;
  getStateOperation;
  idEmpresa
  configured: boolean = null;

  constructor(
    private coalService: CoalService,
    private store: Store<AppState>,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {
    this.getStateOperation = this.store.select(selectUtilsState);
  }
  ngOnInit(): void {
    this.getPaquetes();

    this.operation = this.getStateOperation.subscribe((stateOperation) => {
      if (stateOperation.empresaSeleccionada === undefined) {
				this.configured = false;
				throw new Error('Empresa no configurada. Proceso interrumpido.');
			}
			else {
				this.configured = true;
				this.idEmpresa = stateOperation?.empresaSeleccionada?.id;
			}
    });
  }

  getPaquetes() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`cat-paquetes?filters[publico]=true`)
    .subscribe((res: any) => {
      this.store.dispatch(OcultarSpinner());
      this.paquetes = res.data;
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    })
  }

  openDialog(paquete) {
    const dialogRef = this.dialog.open(StripeChargeComponent, {
      width: '500px',
      height: '830px',
      data: {
        amount: paquete.attributes.precio,
        folios: paquete.attributes.folios,
        pof: paquete.attributes.precio / paquete.attributes.folios,
        idPaquete: paquete.id,
        precio: paquete.attributes.precio,
        paquete: paquete.attributes.paquete,
        descripcion: paquete.attributes.descripcion,
        cat_paquete: paquete.id,
        idEmpresa: this.idEmpresa
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.snackBar.open(
          'Compra realizada correctamente', 'OK', {duration: 5000}
        )
      } else {
        this.snackBar.open(
          'Proceso de compra cancelado.', 'OK', {duration: 10000}
        )
      }
    })
  }

  alertDialog(message: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: { message }
    });

    dialogRef.afterClosed().subscribe((result: any) => {});
  }
}
